import {CatalogOffer, Pagination} from 'epic-graphql-types';

export enum Category {
	ADDONS = 'addons',
	ADDONS_BUNDLE = 'addons/bundle',
	ADDONS_DURABLE = 'addons/durable',
	ADDONS_CONSUMABLE = 'addons/consumable',
	ADDONS_LAUNCHABLE = 'addons/launchable',
	ADDONS_DLC = 'addons/dlc',
	APPLICATION = 'application',
	APPLICATION_MAIN = 'application/main',
	APPLICATIONS = 'applications',
	ASSETS = 'assets',
	ASSETS_CHARACTERS = 'assets/characters',
	AUDIENCE = 'audience',
	BUNDLES = 'bundles',
	BUNDLES_GAMES = 'bundles/games',
	BUNDLES_ADDONS = 'bundles/addons',
	COLLECTION = 'collection',
	/** @deprecated this doesn't appear in Product Framework **/
	COLLECTIONS = 'collections',
	CONSUMABLE = 'consumable',
	DEVELOPER = 'developer',
	DIGITAL_EXTRAS = 'digitalextras',
	DIGITAL_EXTRAS_BOOK = 'digitalextras/book',
	DIGITAL_EXTRAS_SOUNDTRACK = 'digitalextras/soundtrack',
	DIGITAL_EXTRAS_VIDEO = 'digitalextras/video',
	DLC = 'dlc',
	EDITORS = 'editors',
	ENGINES = 'engines',
	FREEGAMES = 'freegames',
	FREEGAMSES_VAULTED = 'freegames/vaulted',
	GAMES = 'games',
	GAMES_DEMO = 'games/demo',
	GAMES_EDITION = 'games/edition',
	GAMES_EDITION_BASE = 'games/edition/base',
	GAMES_EXPERIENCE = 'games/experience',
	HIDDEN = 'hidden',
	MODS = 'mods',
	NON_GAME_SOFTWARE = 'nongamesoftware',
	PLUGINS = 'plugins',
	PLUGINS_ENGINE = 'plugins/engine',
	PUBLIC = 'public',
	TAKEOVER = 'takeover',
	TRIAL = 'games/trial',
	SOFTWARE = 'software',
	SOFTWARE_EDITION = 'software/edition',
	SOFTWARE_EDITION_BASE = 'software/edition/base',
	DEPRECATED = 'deprecated',
	ATTENTION_IN_APP_PURCHASE_SUPPORTED = 'attention/in-app-purchases/supported',
	ATTENTION_IN_APP_PURCHASE_UNSUPPORTED = 'attention/in-app-purchases/unsupported',
	SUBSCRIPTION = 'subscription',
	POINTS = 'points',
	POINTS_PACKS = 'points/packs'
}

export enum CustomProp {
	AVAILABLE_DATE = 'availableDate',
	BLACKLIST = 'com.epicgames.app.blacklist',
	EXTRA_LAUNCH_OPTION_PREFIX = 'extraLaunchOption',
	EXTRA_LAUNCH_OPTION_NAME_SUFFIX = '_Name',
	EXTRA_LAUNCH_OPTION_ARGS_SUFFIX = '_Args',
	EXTRA_LAUNCH_OPTION_PLATFORM_RESTRICTION_SUFFIX = '_PlatformRestriction',
	IS_BETA = 'isBeta',
	IS_DEMO = 'isDemo',
	IS_UPLAY = 'isUplay',
	NEVER_UPDATE = 'NeverUpdate',
	OFFER_NS = 'com.epicgames.app.offerNs',
	PRODUCT_DEVELOPER_NAME = 'developerName',
	PARTNER_LINK_TYPE = 'partnerLinkType',
	PARTNER_LINK_ID = 'partnerLinkId',
	PARENT_PARTNER_LINK_ID = 'parentPartnerLinkId',
	PRODUCT_IS_PRE_PURCHASE = 'isPrepurchase',
	PRODUCT_ORDER_WEIGHT = 'com.epicgames.app.weight',
	PRODUCT_PUBLISHER_NAME = 'publisherName',
	PRODUCT_SLUG = 'com.epicgames.app.productSlug',
	WEB_URL_OVERRIDE = 'com.epicgames.app.webUrlOverride',
	WHITELIST = 'com.epicgames.app.whitelist',
	THIRD_PARTY_MANAGED_APP = 'ThirdPartyManagedApp',
	THIRD_PARTY_MANAGED_PROVIDER = 'ThirdPartyManagedProvider',
	LIBRARY_DISPLAY_VERSION = 'egs.library.display_version',
	ALLOW_MULTIPLE_INSTANCES = 'AllowMultipleInstances',
	SUBSCRIPTION_LINK_ID = 'SubscriptionLinkId'
}

// Special namespace and catalog ID for the launcher
export const LAUNCHER = 'EpicGamesLauncher';
export const NAMESPACE_UE = 'ue';

export enum KeyImageType {
	ANDROIDICON = 'AndroidIcon',
	COMING_SOON = 'ComingSoon',
	COMING_SOON_SMALL = 'ComingSoon_Small',
	GALLERY_IMAGE = 'GalleryImage',
	FEATURED = 'Featured',
	FEATURED_MEDIA = 'featuredMedia',
	GAMEBOX = 'DieselGameBox',
	GAMEBOX_LOGO = 'DieselGameBoxLogo',
	GAMEBOX_TALL = 'DieselGameBoxTall',
	GAMEBOX_WIDE = 'DieselGameBoxWide',
	HERO_CAROUSEL_VIDEO = 'heroCarouselVideo',
	HORIZONTAL = 'horizontal',
	IMAGE_BANNER = 'img_banner',
	IMAGE_SMALL = 'img_small',
	IMAGE_THUMBNAIL = 'img_thumbnail',
	OFFER_IMAGE_TALL = 'OfferImageTall',
	OFFER_IMAGE_WIDE = 'OfferImageWide',
	OGImage = 'OgImage',
	PRODUCT_LOGO = 'ProductLogo',
	SCREENSHOT = 'Screenshot',
	STOREFRONT = 'storefront',
	STORE_FRONT_TALL = 'DieselStoreFrontTall',
	STORE_FRONT_WIDE = 'DieselStoreFrontWide',
	TAKEOVER_LOGO = 'TakeoverLogo',
	TAKEOVER_LOGO_SMALL = 'TakeoverLogoSmall',
	TAKEOVER_TALL = 'TakeoverTall',
	TAKEOVER_WIDE = 'TakeoverWide',
	THUMBNAIL = 'Thumbnail',
	VAULT_CLOSED = 'VaultClosed',
	VERTICAL = 'vertical'
}

// Used to separate tag ids in the query and url params
export const CATALOG_QUERY_TAG_DELIMITER = '|';

export type KeyImages = Record<string, string[]>;
export type CustomAttributes = Record<string, string>;

export interface Seller {
	id: string;
	name: string;
}

export type CurrencySymbol =
	| 'د.إ'
	| '$'
	| 'лв.'
	| 'R$'
	| 'Fr.'
	| '¥'
	| '₡'
	| 'Kč'
	| 'kr.'
	| '€'
	| '£'
	| 'Ft'
	| 'Rp'
	| '₪'
	| '₹'
	| '₩'
	| '₸'
	| 'RM'
	| 'kr'
	| 'S/'
	| '₱'
	| 'zł'
	| 'QR'
	| 'lei'
	| '₽'
	| 'ر.س'
	| 'S$'
	| '฿'
	| '₺'
	| 'NT$'
	| '₴'
	| '₫'
	| 'R';

export enum CurrencyCode {
	AED = 'AED',
	AUD = 'AUD',
	BGN = 'BGN',
	BRL = 'BRL',
	CAD = 'CAD',
	CHF = 'CHF',
	CLP = 'CLP',
	CNY = 'CNY',
	COP = 'COP',
	CRC = 'CRC',
	CZK = 'CZK',
	DKK = 'DKK',
	EUR = 'EUR',
	GBP = 'GBP',
	HKD = 'HKD',
	HUF = 'HUF',
	IDR = 'IDR',
	ILS = 'ILS',
	INR = 'INR',
	JPY = 'JPY',
	KRW = 'KRW',
	KZT = 'KZT',
	MXN = 'MXN',
	MYR = 'MYR',
	NOK = 'NOK',
	NZD = 'NZD',
	PEN = 'PEN',
	PHP = 'PHP',
	PLN = 'PLN',
	QAR = 'QAR',
	RON = 'RON',
	RUB = 'RUB',
	SAR = 'SAR',
	SEK = 'SEK',
	SGD = 'SGD',
	THB = 'THB',
	TRY = 'TRY',
	TWD = 'TWD',
	UAH = 'UAH',
	USD = 'USD',
	UYU = 'UYU',
	VND = 'VND',
	ZAR = 'ZAR'
}

export type CurrencyType = 'REAL' | 'VIRTUAL' | 'GAME';

export interface Currency {
	symbol: CurrencySymbol;
	code: CurrencyCode;
	decimals: number;
	description: string;
	priceRanges: string[];
	truncLength: number;
	type: CurrencyType;
}

export interface Currencies {
	elements: Currency[];
	paging: Pagination;
}

export default {
	categories: Category,
	customProps: CustomProp,
	keyImageTypes: KeyImageType,
	NAMESPACE_UE,
	LAUNCHER,
	CATALOG_QUERY_TAG_DELIMITER
};

export type CatalogUpgradePathType = 'REGULAR' | 'SEASON_PASS';

export type CatalogUpgradePathStatus = 'ACTIVE' | 'DISABLED' | 'DELETED';

export type CatalogEntitlementType =
	| 'EXECUTABLE'
	| 'ENTITLEMENT'
	| 'FRIENDINVITE'
	| 'INGAMEITEM'
	| 'AUDIENCE';

export enum CatalogStatus {
	ACTIVE = 'ACTIVE',
	DELETED = 'DELETED',
	PENDING_APPROVAL = 'PENDING_APPROVAL',
	APPROVED = 'APPROVED',
	CHANGES_NEEDED = 'CHANGES_NEEDED',
	REJECTED = 'REJECTED',
	SUNSET = 'SUNSET'
}

export type CatalogStatusType = `${CatalogStatus}`;

export type CatalogNamespaceAccessType = 'PUBLIC' | 'PRIVATE';

export type CatalogPriceTierType =
	| 'AUTO_WITHOUT_VAT'
	| 'MANUAL_WITH_VAT'
	| 'MANUAL_WITHOUT_VAT'
	| 'MANUAL_VAT_NA';

export type CatalogNamespaceType = 'PRODUCT' | 'SANDBOX';

export type CatalogNamespaceStatus = 'ACTIVE' | 'INACTIVE' | 'DELETED';

export type CatalogCurrencyType = 'REAL' | 'VIRTUAL' | 'IN_GAME';

export type CatalogCurrencySymbolPlacement = 'LEFT' | 'RIGHT';

export type CatalogCountrySellerOfRecord = 'EPIC' | 'EPIC_INT' | 'EMERGENT';

// TODO - validate this interface's types
export interface CatalogAgeGating {
	ratingSystem: string;
	ageControl: number | undefined;
	gameRating: string;
	ratingImage?: string;
	rectangularRatingImage?: string;
	title: string;
	isAgeGated?: boolean;
	descriptor?: string;
	element?: string;
}

export interface CatalogUpgradePathInfo {
	upgradePathType: CatalogUpgradePathType;
	dependentNsOfferIds: string[];
	namespace: string;
	offerId: string;
	id: string;
	upgradePathStatus: CatalogUpgradePathStatus;
	// TODO - get a stronger type for this
	localizationTitles: Record<string, any>;
	totalUpgradePathPricing: Record<string, any>;
}

export enum KeyImageType {
	FeaturedMedia = 'featuredMedia',
	GalleryImage = 'GalleryImage',
	HeroCarouselVideo = 'heroCarouselVideo',
	OfferImageTall = 'OfferImageTall',
	OfferImageWide = 'OfferImageWide',
	Thumbnail = 'Thumbnail',
	OgImage = 'OgImage',
	ProductLogo = 'ProductLogo',
	ProductIcon = 'ProductIcon',
	CoverImage = 'coverImage',
	WebStoreThumbnail = 'WebStoreThumbnail',
	WebStoreBannerImage = 'WebStoreBannerImage'
}

export interface CatalogKeyImage {
	size?: number;
	width?: number;
	alt?: string;
	type: string;
	uploadedDate?: string;
	url: string;
	md5?: string;
	height?: number;
	id?: string;
}

export interface CatalogInstallMode {
	path: string;
	namespace: string;
	name: string;
}

export interface CatalogReleaseInfo {
	compatibleApps: string[];
	versionTitle: string;
	appId: string;
	id: string;
	projectFileLink: string;
	releaseNote: string;
	platform: string[];
	dateAdded: string;
}

// TODO - get this more strongly typed if possible
export type CatalogTechnicalRequirement = Record<string, any>;
// TODO - get this more strongly typed if possible
export type CatalogExternalLink = Record<string, any>;

export interface CatalogApproximateReleasePlan {
	quarter: 'q1' | 'q2' | 'q3' | 'q4';
	month: number;
	day: number;
	year: number;
	releaseDateType: 'BY_YEAR' | 'BY_MONTH' | 'BY_QUARTER' | 'BY_DATE' | 'UNKNOWN';
}

export type CatalogCustomAttributes = Record<
	string,
	{type: string; value: string | undefined} | undefined // undefined to guard against access to a string that is not a defined prop
>;

export interface CatalogOfferInfo {
	upgradePathInfos: unknown;
	majorNsOffers: CatalogOfferInfo[];
	uniqueKey: string;
	namespace: string;
	id: string;
	subNsOffers: unknown;
	status: CatalogStatusType;
	allDependNsOfferIds: string[];
}

export interface CatalogSubOfferDependency {
	nsOfferId: string;
	participationMode: string;
}

export interface CatalogServiceCategory {
	forMarketplace?: boolean;
	path: string;
	name?: string;
	description?: string;
	forSeller?: boolean;
	store?: string;
}

export interface CatalogNamespace {
	parent: string;
	gameType?: string;
	displayName: string;
	eulaIds: string[];
	ageGatings: Record<string, CatalogAgeGating> | undefined;
	accessType: CatalogNamespaceAccessType;
	addVatToPrice: boolean;
	sellerRevenueShare?: number;
	codeName?: string;
	purposeTypes: string[];
	ageGated?: boolean;
	priceTierType: CatalogPriceTierType;
	slug: string;
	countriesBlacklist?: string[];
	taxSkuId: string;
	created: string;
	store: string;
	merchantGroup: string;
	namespaceType: CatalogNamespaceType;
	convenienceFee: boolean;
	name: string;
	defaultPublic: boolean;
	gamePlatform?: string;
	region?: string;
	gameMode?: string;
	countriesWhitelist?: string[];
	updated: string;
	hasDynamicItems: boolean;
	status: CatalogNamespaceStatus;
	ratingAgeGating: Record<string, number>;
}

export interface CatalogCurrency {
	symbol: string;
	code: string;
	decimals: number;
	description: string;
	priceRanges: string[];
	truncLength: number;
	type: CatalogCurrencyType;
}

export interface CatalogCountry {
	currencySymbolPlacement: CatalogCurrencySymbolPlacement;
	subscriptionSupported: boolean;
	code: string;
	displayName: string;
	ratingSystem?: string;
	embargoed: boolean;
	vatReverseCharge: boolean;
	sellerOfRecord: CatalogCountrySellerOfRecord;
	vatChargeRate: number;
	ratingSystems?: string[];
	vatPercentage: number;
	defaultCurrency: string;
	vatIncluded: boolean;
	region: string;
	sellerOfRecordName: string;
	paymentCurrency: string;
}

export interface CatalogSearchMetadata {
	facets?: {
		count: number;
		category: {
			forMarketplace: boolean;
			path: string;
			name: string;
			description: string;
			forSeller: boolean;
			store: string;
		};
	}[];
}

export interface CatalogPaginationContext {
	total: number;
	count: number;
	start: number;
}

export interface CatalogPaginatedResult<T> {
	metadata?: CatalogSearchMetadata;
	elements: T[];
	paging: CatalogPaginationContext;
}

export type CatalogOfferSearchResults = CatalogPaginatedResult<
	CatalogOffer & {
		accessType?: string;
		defaultPublic?: boolean;
		store?: string;
	}
>;

export interface CatalogOfferProduct {
	sandboxId: string;
	offerId?: string;
	offerIds: string[];
}

export interface BaseRating {
	ratingSystem: string;
}

export interface AgeRating extends BaseRating {
	__typename: 'AgeRating';
	ageControl: number;
	contentDescriptors: string[];
	interactiveElements: string[];
	ratingImage?: string;
	ratingSystem: string;
	rectangularRatingImage?: string;
	title: string;
}

export interface UnratedRating extends BaseRating {
	__typename: 'UnratedRating';
}

export interface NoRating extends BaseRating {
	__typename: 'NoRating';
}

export type AgeRatingResponse = AgeRating | UnratedRating | NoRating;
